// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q1/2022dapraiserank/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getList = (page: number) => {
  return http.get(
    `/vote/2022project/q1/2022dapraiserank/controller.php?enews=rank-list&page=${page}`,
  );
};
export { getBaseInfo, getList };
